import React from 'react';
import { useNavigate } from 'react-router';

import { useGetUserPassportQuery } from '@/API/api.slice';
import Locale from '@/config/locale.config';
import { ROUTES } from '@/constants/config';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setUserPassport } from '@/store/slices/auth.slice';

const useUserPassport = () => {
  const { isAuthenticated, isPending: isAuthPending } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const { data, isLoading } = useGetUserPassportQuery(undefined, {
    skip: !isAuthenticated || isAuthPending,
  });

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (isAuthPending || isLoading ) return;

    if (!isLoading && !isAuthenticated) {
      navigate(ROUTES.UNAUTHORIZED);
    }

    if (data) {
      Locale(data.user.locale);
      dispatch(setUserPassport(data));
    }
  }, [data, dispatch, isAuthPending, isAuthenticated, isLoading, navigate]);

  return React.useMemo(() => {
    return {
      isLoading,
    };
  }, [isLoading]);
};

export default useUserPassport;
